import type { StreetLocationConfig } from "../world/streetLocation.ts";

/**
 * Street-caption thresholds in world metres.
 *
 * The wider release radius and switch advantage form the location-label
 * hysteresis: entering a street is prompt, while small nearest-segment changes
 * at junctions do not make the caption flicker.
 */
export const STREET_LOCATION_CONFIG: Readonly<StreetLocationConfig> =
  Object.freeze({
    acquireRadiusM: 18,
    releaseRadiusM: 26,
    switchAdvantageM: 5,
    sampleMovementM: 0.75,
  });
